import { useCallback, useEffect } from "react";
import { useHistory } from "react-router";

import { Grid } from "@material-ui/core";
import { useToastSaurus } from '../../../../service/app/use-cases/toast-saurus'
import { useSessaoAtual } from '../../../../service/app/providers'
import { CircularLoading } from "../../../components";
import { PublicPageHeader } from "../../../components/headers/header-public-page/header-public-page";
import { makeUtilClasses } from "../../../../theme";


export const LogoutPage = () => {
    const { replace: historyReplace } = useHistory();
    const { deslogar, usuario } = useSessaoAtual();
    const utilClasses = makeUtilClasses();
    const { showToast } = useToastSaurus();

    const efetuarLogout = useCallback(() => {
        try {
            deslogar(usuario?.usuarioId || '');
        } catch (e: any) {
            showToast("error", e.message);
        }
        historyReplace("/login");
    }, [deslogar, historyReplace, showToast, usuario?.usuarioId]);

    useEffect(() => {
        efetuarLogout();
    }, [efetuarLogout]);

    return (
        <>
            <PublicPageHeader topOpacity="0.8" />
            <div className={utilClasses.contentCenter}>
                <Grid container className={utilClasses.rootContainer}>
                    <CircularLoading tipo="FULLSIZED" />
                </Grid>
            </div>
        </>
    )
}

export default LogoutPage;


